import React from "react";
import { Routes, Route } from "react-router-dom";
import HeaderPayments from "../Components/Payments/headerPayment";
import ListPayments from "../Components/Payments/listPayments";
import ListRequestPaymentsRefund from "../Components/Payments/requestPaymentRefund";
import ViewPayment from "../Components/Payments/viewPayments";

const PaymentRoutes = () => {
  return (
    <Routes>
      <Route path="/payments" element={<HeaderPayments></HeaderPayments>}></Route>
      <Route path="/payments_list" element={<ListPayments></ListPayments>}></Route>
      <Route path="/request_payments_list" element={<ListRequestPaymentsRefund></ListRequestPaymentsRefund>}></Route>
      <Route path="/payments/:id" element={<ViewPayment></ViewPayment>}></Route>
    </Routes>
  );
};

export default PaymentRoutes;
